var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "das" },
    [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", {
          staticClass: "icon icon-mon-reseau pe-1 ps-2 ps-md-0 text-gray4",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ps-3 ps-md-0" },
          [
            _vm.head
              ? [
                  _c(
                    "a",
                    {
                      attrs: { href: "#modal-das", "data-bs-toggle": "modal" },
                    },
                    [
                      _c("strong", {
                        domProps: { innerHTML: _vm._s(_vm.prefix) },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("strong", {
                    domProps: { innerHTML: _vm._s(" " + _vm.head) },
                  }),
                  _c("br"),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.trunk
              ? [
                  _c(
                    "a",
                    {
                      attrs: { href: "#modal-das", "data-bs-toggle": "modal" },
                    },
                    [
                      _c("strong", {
                        domProps: { innerHTML: _vm._s(_vm.prefix) },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("strong", {
                    domProps: { innerHTML: _vm._s(" " + _vm.trunk) },
                  }),
                  _c("br"),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.member
              ? [
                  _c(
                    "a",
                    {
                      attrs: { href: "#modal-das", "data-bs-toggle": "modal" },
                    },
                    [
                      _c("strong", {
                        domProps: { innerHTML: _vm._s(_vm.prefix) },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("strong", {
                    domProps: { innerHTML: _vm._s(" " + _vm.member) },
                  }),
                  _c("br"),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("ob1-popin-modal-visual", {
        attrs: {
          id: "modal-das",
          "aria-labelledby": "modal-label-das",
          "additional-classes": "d-webview-none d-md-block",
        },
        scopedSlots: _vm._u([
          {
            key: "visual",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    class: [
                      "ob1-modal-img d-webview-none",
                      _vm.isSoshShop ? "bg-primary3" : "bg-black",
                    ],
                  },
                  [
                    _c("div", { staticClass: "image-crop" }, [
                      _c("div", {
                        staticClass: "icon icon-mon-reseau text-white",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("p", {
                  staticClass: "h4",
                  attrs: { id: "modal-label-das" },
                  domProps: { innerHTML: _vm._s(_vm.popinTitle) },
                }),
                _vm._v(" "),
                _c("p", { domProps: { innerHTML: _vm._s(_vm.popinText) } }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }